import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import HelpButton from "../../HelpContent/HelpButton";
import MyIcon from "../MyIcon";
import APICredentialsIcon from "../../../assets/icons/api_cog-01.svg2";
import TickIcon from "../../../assets/icons/tick.svg2";

export default function ApiCredentialsForm() {
  return (
    <div>
      <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker-reverse m-3 ">
        <div className="d-flex">
          <div>
            <MyIcon Icon={APICredentialsIcon} width={30} className="me-2" />
          </div>
          <div>
            <div className="fw-bold">API Credentials</div>
            <div className="small opacity-50">
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
            </div>
          </div>
        </div>
        <div>
          <Form>
            <Form.Group
              as={Row}
              className="mb-3 mt-3"
              controlId="apiEndpointUrl"
            >
              <Form.Label column sm="4" className="fw-bold">
                Endpoint URL:
                <HelpButton />
              </Form.Label>
              <Col sm="8">
                <Form.Control type="text" />
              </Col>
            </Form.Group>
            <hr className="text-secondary" />
            <Form.Group as={Row} className="mb-3" controlId="apiKey">
              <Form.Label column sm="4" className="fw-bold">
                API key <HelpButton />
              </Form.Label>
              <Col sm="8">
                <Form.Control type="text" />
              </Col>
            </Form.Group>
            <hr className="text-secondary" />
            <Form.Group as={Row} className="mb-3" controlId="apiUsername">
              <Form.Label column sm="4" className="fw-bold">
                Username:
                <HelpButton />
              </Form.Label>
              <Col sm="8">
                <Form.Control type="text" />
              </Col>
            </Form.Group>
            <hr className="text-secondary" />

            <Form.Group as={Row} className="mb-3" controlId="apiPassword">
              <Form.Label column sm="4" className="fw-bold">
                Password:
                <HelpButton />
              </Form.Label>
              <Col sm="8">
                <Form.Control type="password" />
              </Col>
            </Form.Group>
            <hr className="text-secondary" />
          </Form>
          <div className="d-flex justify-content-end">
            <Button
              type="submit"
              className="btn btn-colored-reverse rounded-pill fw-bold px-4 "
            >
          <  TickIcon className="text-white me-2" width={15}/> AUTHENTICATE
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
